var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgNftRoyalContinueIcon(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#F0D242",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.435 24.219c-.902 4.334-7.034 10.78-12.616 10.78a8.068 8.068 0 01-2.435-.514 3.163 3.163 0 01-.734-.352A3.469 3.469 0 0114 31.141v-.322c0-.125.036-.257.066-.403.031-.147.07-.291.117-.433 1.012-3.667 3.528-3.791 4.496-8.39a6.483 6.483 0 016.155-5.133 6.14 6.14 0 011.54.132l.176.044c.22.012.44.047.653.103a6.499 6.499 0 014.232 7.48z",
    fill: "#FAB14B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.01 23.362c-.896 4.304-6.83 10.567-12.33 10.772A3.47 3.47 0 0114 31.142v-.322c0-.125.036-.257.066-.404.03-.146.07-.29.117-.432 1.012-3.667 3.528-3.792 4.496-8.39a6.482 6.482 0 016.154-5.133 6.49 6.49 0 013.176 6.9z",
    fill: "#FFD966"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.427 16.571c.485-2.64 3.521-5.405 9.294-1.965 0 0-2.846 3.043-6.52 2.808a9.3 9.3 0 01-2.715-.359c-.11-.059-.073-.389-.059-.484z",
    fill: "#70CC70"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.344 16.263c-3.594 2.237 6.727 5.984 7.057 9.277A10.91 10.91 0 0035 20.333c0-2.735-4.394-6.717-8.656-4.07z",
    fill: "#7EE67E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.935 21.561c.681-1.201.65-2.506-.069-2.913-.719-.407-1.854.237-2.535 1.438-.68 1.202-.65 2.506.069 2.913.719.408 1.854-.236 2.535-1.438z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(14 13)",
    d: "M0 0h21v22H0z"
  })))));
}
export default SvgNftRoyalContinueIcon;